import axios from 'config/axios'

const getSunshineToken = externalId => axios.post('auth/zendesk-sunshine/token', {
  channelDescription: 'web',
  externalId
}).catch(err => console.log('getSunshineToken err', err))
// TODO (sunshine): add error behavior

export default getSunshineToken
